"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Slide = _interopRequireDefault(require("@mui/material/Slide"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Bubble = _interopRequireDefault(require("../../components/Bubble"));
var _Tooltip = _interopRequireDefault(require("../../components/Tooltip"));
var _ContainerControlSite = _interopRequireDefault(require("../../components/Divs/ContainerControlSite"));
var _ClassPricingContainer = _interopRequireDefault(require("./ClassPricingContainer"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Pricing = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Pricing, _PureComponent);
  function Pricing() {
    var _this;
    (0, _classCallCheck2["default"])(this, Pricing);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Pricing, [].concat(args)), _this.state = {
      classIDs: _sbUtils.helpers.sortObjByTitle(_this.props.classData),
      selectedClassID: null,
      showSubmitPricingDialog: false
    }, _this._transition = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
      return /*#__PURE__*/_react["default"].createElement(_Slide["default"], (0, _extends2["default"])({
        direction: "up",
        ref: ref
      }, props));
    }), _this._selectClass = function (selectedClassID) {
      _this.setState({
        selectedClassID: selectedClassID
      });
    }, _this._submitPricing = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var success;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.props.submitPricing(_this.props.currentAccountMeta.accountID);
          case 2:
            success = _context.sent;
            if (!success) {
              _context.next = 8;
              break;
            }
            if (!_this.props.isRevision) {
              _context.next = 7;
              break;
            }
            _this.props.setSelectedSection('revision-assign-plans');
            return _context.abrupt("return", null);
          case 7:
            _this.setState({
              showSubmitPricingDialog: false
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._goBack = function () {
      _this.setState({
        selectedClassID: null
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  } // eslint-disable-next-line consistent-return
  (0, _createClass2["default"])(Pricing, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      if (this.state.selectedClassID) {
        return /*#__PURE__*/_react["default"].createElement(_ClassPricingContainer["default"], {
          selectedClass: this.props.classData[this.state.selectedClassID],
          selectedClassID: this.state.selectedClassID,
          quote: this.props.quote,
          isQuote: this.props.isQuote,
          isRevision: this.props.isRevision,
          classData: this.props.classData,
          designs: this.props.designs,
          commissions: this.props.commissions,
          currentAccountMeta: this.props.currentAccountMeta,
          isMasterSite: this.props.isMasterSite,
          submitPricing: this.props.submitPricing,
          savePricingInput: this.props.savePricingInput,
          savePricing: this.props.savePricing,
          saveTelusDrugPlanID: this.props.saveTelusDrugPlanID,
          getPricingRevisions: this.props.getPricingRevisions,
          getSinglePricingRevision: this.props.getSinglePricingRevision,
          saveCoverages: this.props.saveCoverages,
          goBack: this._goBack,
          loading: this.props.loading,
          whitelabel: this.props.whitelabel
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_ContainerControlSite["default"], {
        id: "account-pricing"
      }, /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.pricing),
        subtitle: _i18n["default"].t(_tokens["default"].labels.planDesign.reviewAndSetPricing),
        btn: this.props.quote && this.props.currentAccountMeta.state <= 4 || this.props.isRevision && this.props.step <= 2,
        btnName: _i18n["default"].t(_tokens["default"].buttons.submit),
        btnOnClick: function btnOnClick() {
          if (_this2.props.isRevision) {
            _this2._submitPricing();
          } else {
            _this2.setState({
              showSubmitPricingDialog: true
            });
          }
        }
      }), this.state.classIDs.map(function (classID) {
        var data = _this2.props.classData[classID];

        // if it's modular flex then we don't want to show the parent classes, only the flex classes
        if (data.isModular && data.parentClassID === null) {
          return null;
        }
        return data.description ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          tip: data.description,
          placement: "top",
          arrow: true,
          display: "inline-block",
          key: classID
        }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
          label: "".concat(_i18n["default"].t(_tokens["default"].titles["class"]), ": ").concat(data.title),
          isSelected: true,
          onClick: function onClick() {
            return _this2._selectClass(classID);
          },
          clickable: true,
          customStyle: {
            marginLeft: "5px",
            marginRight: "5px"
          }
        })) : /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
          key: classID,
          label: "".concat(_i18n["default"].t(_tokens["default"].titles["class"]), ": ").concat(data.title),
          isSelected: true,
          onClick: function onClick() {
            return _this2._selectClass(classID);
          },
          clickable: true,
          customStyle: {
            marginLeft: "5px",
            marginRight: "5px"
          }
        });
      }), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showSubmitPricingDialog,
        transitionComponent: this._transition,
        close: function close() {
          _this2.setState({
            showSubmitPricingDialog: false
          });
        },
        title: _i18n["default"].t(_tokens["default"].titles.areYouSure),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this._submitPricing,
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons["continue"]),
        customContainerStyle: {
          maxWidth: "500px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.clickAcceptPricing)), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        customImageStyle: {
          top: '50%'
        }
      })));
    }
  }]);
  return Pricing;
}(_react.PureComponent);
var _default = exports["default"] = Pricing;